import { useAuth as libUseAuth } from "@marekl/adminer";
import type { User } from "./queries";

/** App-typed wrapper around `useAuth()` that returns the letterman User. */
export function useAuth() {
  return libUseAuth<User>();
}

/**
 * True when the current user may mutate (role "admin"). Viewers get the same
 * pages read-only — every mutating button/modal is gated on this.
 */
export function useIsAdmin(): boolean {
  const { user } = useAuth();
  return user?.role === "admin";
}
